
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("9uh43", function(module, exports) {

$parcel$export(module.exports, "default", () => $058e544ba1e32893$export$2e2bcd8739ae039);

var $fI8Eh = parcelRequire("fI8Eh");

var $058e544ba1e32893$export$2e2bcd8739ae039 = (0, $fI8Eh.Client);

});
parcelRegister("fI8Eh", function(module, exports) {

$parcel$export(module.exports, "Client", () => $92623acccd5395a2$export$1f2bb630327ac4b6);

var $7n9mn = parcelRequire("7n9mn");

var $ltVbq = parcelRequire("ltVbq");

var $fMN5M = parcelRequire("fMN5M");

var $cX21x = parcelRequire("cX21x");

var $bqxYr = parcelRequire("bqxYr");

var $96TaD = parcelRequire("96TaD");

var $dS9cn = parcelRequire("dS9cn");
const $92623acccd5395a2$var$PLATFORM = 'WEB';
const $92623acccd5395a2$var$version = "0.0.0-use.local";
const $92623acccd5395a2$export$a1cc5ecc39716e2b = 1000;
const $92623acccd5395a2$export$fc27646dc891c6e0 = 10;
const $92623acccd5395a2$var$SUBSCRIBE_DEBOUNCE_TIME_IN_MILLISECONDS = 10;
class $92623acccd5395a2$export$1f2bb630327ac4b6 {
    constructor(config, protocols){
        this.eventEmitter = new (0, $7n9mn.EventEmitter2)({
            maxListeners: 500,
            wildcard: true,
            delimiter: ':'
        });
        this.currentChannels = new Set();
        this.capabilities = [];
        this.protocols = new Map();
        this.retryCount = 0;
        this.subscribeDebounced = null;
        this.subscribedToBaseEvents = false;
        this.subscribeBaseRequest = {
            clientInfo: {
                version: $92623acccd5395a2$var$version,
                platform: $92623acccd5395a2$var$PLATFORM,
                capabilities: this.capabilities
            }
        };
        this.onMessage = (event, data)=>{
            this.eventEmitter.emit(event, event, data);
        };
        this.onAccessDenied = ()=>{
            (0, $96TaD.logDebug)('Access denied');
            if (this.retryCount > $92623acccd5395a2$export$fc27646dc891c6e0) {
                (0, $96TaD.logError)('Retry count exceeded');
                return;
            }
            return new Promise((resolve, reject)=>{
                window.setTimeout(()=>{
                    this.subscribeToCurrentChannels().then(()=>resolve(this)).catch(reject);
                }, $92623acccd5395a2$export$a1cc5ecc39716e2b * 2 ** this.retryCount);
                this.retryCount++;
            });
        };
        this.onNetworkUp = ()=>{
            this.retryCount = 0;
            this.eventEmitter.emit((0, $ltVbq.SpecialEventType).CONNECTED);
        };
        this.onReconnect = ()=>{
            this.eventEmitter.emit((0, $ltVbq.SpecialEventType).RECONNECT);
        };
        this.config = config;
        if (!protocols) {
            protocols = [];
            if (config.apsProtocol?.enabled) protocols.push(new (0, $bqxYr.default)(config.apsProtocol?.url, config.apsProtocol?.preferredTransport, config.apsProtocol?.skipFallback, config.analyticsClient));
        }
        this.subscribeBaseRequest.clientInfo.capabilities = this.registerProtocols(protocols);
    }
    on(event, listener) {
        this.eventEmitter.on(event, listener);
        return this;
    }
    off(event, listener) {
        this.eventEmitter.removeListener(event, listener);
        return this;
    }
    join(aris) {
        let channelsChanged = false;
        aris.forEach((ari)=>{
            if (!this.currentChannels.has(ari)) {
                this.currentChannels.add(ari);
                channelsChanged = true;
            }
        });
        if (channelsChanged) return this.debouncedSubscribeToCurrentChannels();
        return Promise.resolve(this);
    }
    leave(aris) {
        let channelsChanged = false;
        aris.forEach((ari)=>{
            if (this.currentChannels.has(ari)) {
                this.currentChannels.delete(ari);
                channelsChanged = true;
            }
        });
        if (channelsChanged) return this.debouncedSubscribeToCurrentChannels();
        return Promise.resolve(this);
    }
    networkUp() {
        this.retryCount = 0;
        if (this.currentProtocol) this.currentProtocol.networkUp();
    }
    networkDown() {
        if (this.currentProtocol) this.currentProtocol.networkDown();
    }
    debouncedSubscribeToCurrentChannels() {
        return new Promise((resolve, reject)=>{
            if (this.subscribeDebounced) window.clearTimeout(this.subscribeDebounced);
            this.subscribeDebounced = window.setTimeout(()=>{
                this.subscribeToCurrentChannels().then(()=>resolve(this)).catch(reject);
            }, $92623acccd5395a2$var$SUBSCRIBE_DEBOUNCE_TIME_IN_MILLISECONDS);
        });
    }
    registerProtocols(protocols) {
        let capabilities = [];
        protocols.forEach((protocol)=>{
            this.protocols.set(protocol.getType(), protocol);
            capabilities = capabilities.concat(protocol.getCapabilities());
        });
        return capabilities;
    }
    subscribeToCurrentChannels() {
        const channels = Array.from(this.currentChannels.values());
        if (channels.length === 0) {
            this.currentProtocol = undefined;
            this.protocols.forEach((protocol)=>protocol.unsubscribeAll());
            this.eventEmitter.removeAllListeners();
            this.subscribedToBaseEvents = false;
            return Promise.resolve();
        } else if (!this.subscribedToBaseEvents) {
            this.protocols.forEach((protocol)=>{
                protocol.on((0, $fMN5M.EventType).MESSAGE, this.onMessage);
                protocol.on((0, $fMN5M.EventType).ACCESS_DENIED, this.onAccessDenied);
                protocol.on((0, $fMN5M.EventType).NETWORK_UP, this.onNetworkUp);
                protocol.on((0, $fMN5M.EventType).RECONNECT, this.onReconnect);
            });
            this.subscribedToBaseEvents = true;
        }
        return this.fetchSubscribeProtocol(channels).then((subscribeProtocol)=>{
            const protocolConfig = subscribeProtocol.protocol;
            if (!protocolConfig) {
                (0, $96TaD.logError)('Failed to retrieve subscription configuration', subscribeProtocol.errors);
                return;
            }
            this.currentProtocol = this.protocols.get(protocolConfig.type);
            if (!this.currentProtocol) {
                (0, $96TaD.logInfo)(`Unknown protocol ${protocolConfig.type}, using noop one.`);
                this.currentProtocol = new (0, $cX21x.default)();
            }
            this.currentProtocol.subscribe(protocolConfig);
        });
    }
    fetchSubscribeProtocol(aris) {
        return (0, $dS9cn.utils).requestService(this.config, {
            path: 'subscribe',
            requestInit: {
                method: 'POST',
                body: JSON.stringify({
                    ...this.subscribeBaseRequest,
                    product: this.config.product,
                    channels: aris
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        }).then((data)=>{
            return data;
        });
    }
}

});
parcelRegister("7n9mn", function(module, exports) {

var $6cAn5 = parcelRequire("6cAn5");
!function(undefined) {
    var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    var defaultMaxListeners = 10;
    function init() {
        this._events = {};
        if (this._conf) configure.call(this, this._conf);
    }
    function configure(conf) {
        if (conf) {
            this._conf = conf;
            conf.delimiter && (this.delimiter = conf.delimiter);
            this._maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
            conf.wildcard && (this.wildcard = conf.wildcard);
            conf.newListener && (this.newListener = conf.newListener);
            conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
            if (this.wildcard) this.listenerTree = {};
        } else this._maxListeners = defaultMaxListeners;
    }
    function logPossibleMemoryLeak(count, eventName) {
        var errorMsg = "(node) warning: possible EventEmitter memory leak detected. " + count + ' listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.';
        if (this.verboseMemoryLeak) errorMsg += ' Event name: ' + eventName + '.';
        if (typeof $6cAn5 !== 'undefined' && $6cAn5.emitWarning) {
            var e = new Error(errorMsg);
            e.name = 'MaxListenersExceededWarning';
            e.emitter = this;
            e.count = count;
            $6cAn5.emitWarning(e);
        } else {
            console.error(errorMsg);
            if (console.trace) console.trace();
        }
    }
    function EventEmitter(conf) {
        this._events = {};
        this.newListener = false;
        this.verboseMemoryLeak = false;
        configure.call(this, conf);
    }
    EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
    //
    // Attention, function return type now is array, always !
    // It has zero elements if no any matches found and one or more
    // elements (leafs) if there are matches
    //
    function searchListenerTree(handlers, type, tree, i) {
        if (!tree) return [];
        var listeners = [], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached, typeLength = type.length, currentType = type[i], nextType = type[i + 1];
        if (i === typeLength && tree._listeners) {
            //
            // If at the end of the event(s) list and the tree has listeners
            // invoke those listeners.
            //
            if (typeof tree._listeners === 'function') {
                handlers && handlers.push(tree._listeners);
                return [
                    tree
                ];
            } else {
                for(leaf = 0, len = tree._listeners.length; leaf < len; leaf++)handlers && handlers.push(tree._listeners[leaf]);
                return [
                    tree
                ];
            }
        }
        if (currentType === '*' || currentType === '**' || tree[currentType]) {
            //
            // If the event emitted is '*' at this part
            // or there is a concrete match at this patch
            //
            if (currentType === '*') {
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 1));
                return listeners;
            } else if (currentType === '**') {
                endReached = i + 1 === typeLength || i + 2 === typeLength && nextType === '*';
                if (endReached && tree._listeners) // The next element has a _listeners, add it to the handlers.
                listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
                    if (branch === '*' || branch === '**') {
                        if (tree[branch]._listeners && !endReached) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                        listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                    } else if (branch === nextType) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 2));
                    else // No match on this one, shift into the tree but not in the type array.
                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                }
                return listeners;
            }
            listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i + 1));
        }
        xTree = tree['*'];
        if (xTree) //
        // If the listener tree will allow any match for this part,
        // then recursively explore all branches of the tree
        //
        searchListenerTree(handlers, type, xTree, i + 1);
        xxTree = tree['**'];
        if (xxTree) {
            if (i < typeLength) {
                if (xxTree._listeners) // If we have a listener on a '**', it will catch all, so add its handler.
                searchListenerTree(handlers, type, xxTree, typeLength);
                // Build arrays of matching next branches and others.
                for(branch in xxTree)if (branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
                    if (branch === nextType) // We know the next element will match, so jump twice.
                    searchListenerTree(handlers, type, xxTree[branch], i + 2);
                    else if (branch === currentType) // Current node matches, move into the tree.
                    searchListenerTree(handlers, type, xxTree[branch], i + 1);
                    else {
                        isolatedBranch = {};
                        isolatedBranch[branch] = xxTree[branch];
                        searchListenerTree(handlers, type, {
                            '**': isolatedBranch
                        }, i + 1);
                    }
                }
            } else if (xxTree._listeners) // We have reached the end and still on a '**'
            searchListenerTree(handlers, type, xxTree, typeLength);
            else if (xxTree['*'] && xxTree['*']._listeners) searchListenerTree(handlers, type, xxTree['*'], typeLength);
        }
        return listeners;
    }
    function growListenerTree(type, listener) {
        type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
        //
        // Looks for two consecutive '**', if so, don't add the event at all.
        //
        for(var i = 0, len = type.length; i + 1 < len; i++){
            if (type[i] === '**' && type[i + 1] === '**') return;
        }
        var tree = this.listenerTree;
        var name = type.shift();
        while(name !== undefined){
            if (!tree[name]) tree[name] = {};
            tree = tree[name];
            if (type.length === 0) {
                if (!tree._listeners) tree._listeners = listener;
                else {
                    if (typeof tree._listeners === 'function') tree._listeners = [
                        tree._listeners
                    ];
                    tree._listeners.push(listener);
                    if (!tree._listeners.warned && this._maxListeners > 0 && tree._listeners.length > this._maxListeners) {
                        tree._listeners.warned = true;
                        logPossibleMemoryLeak.call(this, tree._listeners.length, name);
                    }
                }
                return true;
            }
            name = type.shift();
        }
        return true;
    }
    // By default EventEmitters will print a warning if more than
    // 10 listeners are added to it. This is a useful default which
    // helps finding memory leaks.
    //
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.delimiter = '.';
    EventEmitter.prototype.setMaxListeners = function(n) {
        if (n !== undefined) {
            this._maxListeners = n;
            if (!this._conf) this._conf = {};
            this._conf.maxListeners = n;
        }
    };
    EventEmitter.prototype.event = '';
    EventEmitter.prototype.once = function(event, fn) {
        return this._once(event, fn, false);
    };
    EventEmitter.prototype.prependOnceListener = function(event, fn) {
        return this._once(event, fn, true);
    };
    EventEmitter.prototype._once = function(event, fn, prepend) {
        this._many(event, 1, fn, prepend);
        return this;
    };
    EventEmitter.prototype.many = function(event, ttl, fn) {
        return this._many(event, ttl, fn, false);
    };
    EventEmitter.prototype.prependMany = function(event, ttl, fn) {
        return this._many(event, ttl, fn, true);
    };
    EventEmitter.prototype._many = function(event, ttl, fn, prepend) {
        var self = this;
        if (typeof fn !== 'function') throw new Error('many only accepts instances of Function');
        function listener() {
            if (--ttl === 0) self.off(event, listener);
            return fn.apply(this, arguments);
        }
        listener._origin = fn;
        this._on(event, listener, prepend);
        return self;
    };
    EventEmitter.prototype.emit = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return false;
        }
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all && this._all.length) {
            handler = this._all.slice();
            if (al > 3) {
                args = new Array(al);
                for(j = 0; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this, type);
                        break;
                    case 2:
                        handler[i].call(this, type, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, type, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
            handler = this._events[type];
            if (typeof handler === 'function') {
                this.event = type;
                switch(al){
                    case 1:
                        handler.call(this);
                        break;
                    case 2:
                        handler.call(this, arguments[1]);
                        break;
                    case 3:
                        handler.call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        args = new Array(al - 1);
                        for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                        handler.apply(this, args);
                }
                return true;
            } else if (handler) // need to make copy of handlers because list can change in the middle
            // of emit call
            handler = handler.slice();
        }
        if (handler && handler.length) {
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this);
                        break;
                    case 2:
                        handler[i].call(this, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
            return true;
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) throw arguments[1]; // Unhandled 'error' event
            else throw new Error("Uncaught, unspecified 'error' event.");
            return false;
        }
        return !!this._all;
    };
    EventEmitter.prototype.emitAsync = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return Promise.resolve([
                false
            ]);
        }
        var promises = [];
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all) {
            if (al > 3) {
                args = new Array(al);
                for(j = 1; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = this._all.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(this._all[i].call(this, type));
                        break;
                    case 2:
                        promises.push(this._all[i].call(this, type, arguments[1]));
                        break;
                    case 3:
                        promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(this._all[i].apply(this, args));
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else handler = this._events[type];
        if (typeof handler === 'function') {
            this.event = type;
            switch(al){
                case 1:
                    promises.push(handler.call(this));
                    break;
                case 2:
                    promises.push(handler.call(this, arguments[1]));
                    break;
                case 3:
                    promises.push(handler.call(this, arguments[1], arguments[2]));
                    break;
                default:
                    args = new Array(al - 1);
                    for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                    promises.push(handler.apply(this, args));
            }
        } else if (handler && handler.length) {
            handler = handler.slice();
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(handler[i].call(this));
                        break;
                    case 2:
                        promises.push(handler[i].call(this, arguments[1]));
                        break;
                    case 3:
                        promises.push(handler[i].call(this, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(handler[i].apply(this, args));
                }
            }
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) return Promise.reject(arguments[1]); // Unhandled 'error' event
            else return Promise.reject("Uncaught, unspecified 'error' event.");
        }
        return Promise.all(promises);
    };
    EventEmitter.prototype.on = function(type, listener) {
        return this._on(type, listener, false);
    };
    EventEmitter.prototype.prependListener = function(type, listener) {
        return this._on(type, listener, true);
    };
    EventEmitter.prototype.onAny = function(fn) {
        return this._onAny(fn, false);
    };
    EventEmitter.prototype.prependAny = function(fn) {
        return this._onAny(fn, true);
    };
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    EventEmitter.prototype._onAny = function(fn, prepend) {
        if (typeof fn !== 'function') throw new Error('onAny only accepts instances of Function');
        if (!this._all) this._all = [];
        // Add the function to the event listener collection.
        if (prepend) this._all.unshift(fn);
        else this._all.push(fn);
        return this;
    };
    EventEmitter.prototype._on = function(type, listener, prepend) {
        if (typeof type === 'function') {
            this._onAny(type, listener);
            return this;
        }
        if (typeof listener !== 'function') throw new Error('on only accepts instances of Function');
        this._events || init.call(this);
        // To avoid recursion in the case that type == "newListeners"! Before
        // adding it to the listeners, first emit "newListeners".
        this.emit('newListener', type, listener);
        if (this.wildcard) {
            growListenerTree.call(this, type, listener);
            return this;
        }
        if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
        this._events[type] = listener;
        else {
            if (typeof this._events[type] === 'function') // Change to array.
            this._events[type] = [
                this._events[type]
            ];
            // If we've already got an array, just add
            if (prepend) this._events[type].unshift(listener);
            else this._events[type].push(listener);
            // Check for listener leak
            if (!this._events[type].warned && this._maxListeners > 0 && this._events[type].length > this._maxListeners) {
                this._events[type].warned = true;
                logPossibleMemoryLeak.call(this, this._events[type].length, type);
            }
        }
        return this;
    };
    EventEmitter.prototype.off = function(type, listener) {
        if (typeof listener !== 'function') throw new Error('removeListener only takes instances of Function');
        var handlers, leafs = [];
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
        } else {
            // does not use listeners(), so no side effect of creating _events[type]
            if (!this._events[type]) return this;
            handlers = this._events[type];
            leafs.push({
                _listeners: handlers
            });
        }
        for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
            var leaf = leafs[iLeaf];
            handlers = leaf._listeners;
            if (isArray(handlers)) {
                var position = -1;
                for(var i = 0, length = handlers.length; i < length; i++)if (handlers[i] === listener || handlers[i].listener && handlers[i].listener === listener || handlers[i]._origin && handlers[i]._origin === listener) {
                    position = i;
                    break;
                }
                if (position < 0) continue;
                if (this.wildcard) leaf._listeners.splice(position, 1);
                else this._events[type].splice(position, 1);
                if (handlers.length === 0) {
                    if (this.wildcard) delete leaf._listeners;
                    else delete this._events[type];
                }
                this.emit("removeListener", type, listener);
                return this;
            } else if (handlers === listener || handlers.listener && handlers.listener === listener || handlers._origin && handlers._origin === listener) {
                if (this.wildcard) delete leaf._listeners;
                else delete this._events[type];
                this.emit("removeListener", type, listener);
            }
        }
        function recursivelyGarbageCollect(root) {
            if (root === undefined) return;
            var keys = Object.keys(root);
            for(var i in keys){
                var key = keys[i];
                var obj = root[key];
                if (obj instanceof Function || typeof obj !== "object" || obj === null) continue;
                if (Object.keys(obj).length > 0) recursivelyGarbageCollect(root[key]);
                if (Object.keys(obj).length === 0) delete root[key];
            }
        }
        recursivelyGarbageCollect(this.listenerTree);
        return this;
    };
    EventEmitter.prototype.offAny = function(fn) {
        var i = 0, l = 0, fns;
        if (fn && this._all && this._all.length > 0) {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)if (fn === fns[i]) {
                fns.splice(i, 1);
                this.emit("removeListenerAny", fn);
                return this;
            }
        } else {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)this.emit("removeListenerAny", fns[i]);
            this._all = [];
        }
        return this;
    };
    EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
    EventEmitter.prototype.removeAllListeners = function(type) {
        if (arguments.length === 0) {
            !this._events || init.call(this);
            return this;
        }
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
            for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
                var leaf = leafs[iLeaf];
                leaf._listeners = null;
            }
        } else if (this._events) this._events[type] = null;
        return this;
    };
    EventEmitter.prototype.listeners = function(type) {
        if (this.wildcard) {
            var handlers = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
            return handlers;
        }
        this._events || init.call(this);
        if (!this._events[type]) this._events[type] = [];
        if (!isArray(this._events[type])) this._events[type] = [
            this._events[type]
        ];
        return this._events[type];
    };
    EventEmitter.prototype.eventNames = function() {
        return Object.keys(this._events);
    };
    EventEmitter.prototype.listenerCount = function(type) {
        return this.listeners(type).length;
    };
    EventEmitter.prototype.listenersAny = function() {
        if (this._all) return this._all;
        else return [];
    };
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define(function() {
        return EventEmitter;
    });
    else // CommonJS
    module.exports = EventEmitter;
}();

});

parcelRegister("ltVbq", function(module, exports) {

$parcel$export(module.exports, "SpecialEventType", () => $1136aa42fe738c7f$export$6221d17ecafe3bf9);
$parcel$export(module.exports, "APSTransportType", () => $1136aa42fe738c7f$export$2103d8d1743deded);
var $1136aa42fe738c7f$export$6221d17ecafe3bf9 = /*#__PURE__*/ function(SpecialEventType) {
    SpecialEventType["ERROR"] = "ERROR";
    SpecialEventType["CONNECTED"] = "CONNECTED";
    SpecialEventType["RECONNECT"] = "RECONNECT";
    return SpecialEventType;
}({});
var $1136aa42fe738c7f$export$2103d8d1743deded = /*#__PURE__*/ function(APSTransportType) {
    APSTransportType["HTTP"] = "HTTP";
    APSTransportType["WEBSOCKET"] = "WEBSOCKET";
    return APSTransportType;
}({});

});

parcelRegister("fMN5M", function(module, exports) {

$parcel$export(module.exports, "EventType", () => $b2bb76bc288f4e78$export$3d7865934588d77e);
var $b2bb76bc288f4e78$export$3d7865934588d77e = /*#__PURE__*/ function(EventType) {
    EventType["MESSAGE"] = "MESSAGE";
    EventType["CONNECTED"] = "CONNECTED";
    EventType["ACCESS_DENIED"] = "ACCESS_DENIED";
    EventType["NETWORK_DOWN"] = "NETWORK_DOWN";
    EventType["NETWORK_UP"] = "NETWORK_UP";
    EventType["RECONNECT"] = "RECONNECT";
    return EventType;
}({});

});

parcelRegister("cX21x", function(module, exports) {

$parcel$export(module.exports, "default", () => $1415b10ab6b561d3$export$2e2bcd8739ae039);
class $1415b10ab6b561d3$export$2e2bcd8739ae039 {
    getType() {
        return 'noop';
    }
    subscribe(_) {}
    unsubscribeAll() {}
    getCapabilities() {
        return [];
    }
    on(_event, _handler) {}
    off(_event, _handler) {}
    networkUp() {}
    networkDown() {}
}

});

parcelRegister("bqxYr", function(module, exports) {

$parcel$export(module.exports, "default", () => $00ceee283bd0c427$export$2e2bcd8739ae039);

var $ltVbq = parcelRequire("ltVbq");

var $7n9mn = parcelRequire("7n9mn");

var $96TaD = parcelRequire("96TaD");

var $8qNPu = parcelRequire("8qNPu");

var $5DEsG = parcelRequire("5DEsG");

var $alHzf = parcelRequire("alHzf");

var $asKgz = parcelRequire("asKgz");
class $00ceee283bd0c427$export$2e2bcd8739ae039 {
    /**
	 * @param apsUrl the URL used to initiate a Web Socket connection with Atlassian PubSub.
	 * Defaults to the path '/gateway/wss/fps', relative to the domain of the current window.location.
	 * @param preferredTransport indicates which type of transport the APS client should use. The default
	 * value is WEBSOCKET.
	 * @param skipFallback indicates that this class should not attempt to reconnected using the fallback transport
	 * in case the primary one fails. This value should, most of the time, be 'false' on a real client.
	 * @param analyticsWebClient a GasV3 AnalyticsWebClient instance which will be used to emit operational events
	 */ constructor(apsUrl = $00ceee283bd0c427$export$2e2bcd8739ae039.getDefaultUrl(), preferredTransport = (0, $ltVbq.APSTransportType).WEBSOCKET, skipFallback = false, analyticsWebClient){
        this.url = apsUrl;
        this.eventEmitter = new (0, $7n9mn.EventEmitter2)();
        this.skipFallback = skipFallback;
        this.analyticsClient = (0, $asKgz.default)(analyticsWebClient);
        const transportParams = {
            url: this.url,
            eventEmitter: this.eventEmitter,
            analyticsClient: this.analyticsClient
        };
        const paramsActive = {
            ...transportParams,
            isFallback: false
        };
        const paramsFallback = {
            ...transportParams,
            isFallback: true
        };
        if (preferredTransport === (0, $ltVbq.APSTransportType).WEBSOCKET) {
            this.activeTransport = new (0, $alHzf.default)(paramsActive);
            this.fallbackTransport = new (0, $8qNPu.default)(paramsFallback);
        } else {
            this.activeTransport = new (0, $8qNPu.default)(paramsActive);
            this.fallbackTransport = new (0, $alHzf.default)(paramsFallback);
        }
    }
    static{
        this.getDefaultUrl = ()=>{
            return new URL((0, $5DEsG.APS_STARGATE_PATH), window.location.origin);
        };
    }
    getCapabilities() {
        return [
            'APS'
        ];
    }
    getType() {
        return 'aps';
    }
    /**
	 * The APS protocol does not implement 'networkDown' or 'networkUp'.
	 * These functions are never called by our primary consumers.
	 */ networkDown() {
        (0, $96TaD.logInfo)("the 'networkDown()' method is not supported by the APS protocol");
    }
    /**
	 * The APS protocol does not implement 'networkDown' or 'networkUp'.
	 * These functions are never called by our primary consumers.
	 */ networkUp() {
        (0, $96TaD.logInfo)("the 'networkUp()' method is not supported by the APS protocol");
    }
    off(event, handler) {
        this.eventEmitter.off(event, handler);
    }
    on(event, handler) {
        this.eventEmitter.on(event, handler);
    }
    subscribe(config) {
        this.activeTransport.subscribe(new Set(config.channels)).catch((errorPrimary)=>{
            (0, $96TaD.logDebug)(`Could not subscribe using primary transport: ${this.activeTransport.transportType()}. Will fallback? ${!this.skipFallback}`, errorPrimary);
            if (this.skipFallback) (0, $96TaD.logDebug)('Skipping subscription fallback');
            else {
                this.analyticsClient.sendEvent('aps-protocol', 'falling back');
                this.activeTransport = this.fallbackTransport;
                (0, $96TaD.logDebug)(`Retrying with fallback transport: ${this.fallbackTransport.transportType()}`);
                this.activeTransport.subscribe(new Set(config.channels)).catch((errorFallback)=>{
                    // should not happen, since we retry forever
                    this.analyticsClient.sendEvent('aps-protocol', 'fall back failed', {
                        error: errorFallback.message || 'Unknown error'
                    });
                });
            }
        });
    }
    unsubscribeAll() {
        this.eventEmitter.removeAllListeners();
        this.activeTransport.close();
    }
}

});
parcelRegister("96TaD", function(module, exports) {

$parcel$export(module.exports, "logDebug", () => $d1036e2f13271908$export$4cdc8edb1e3c510c);
$parcel$export(module.exports, "logInfo", () => $d1036e2f13271908$export$89c0607256d35f0a);
$parcel$export(module.exports, "logError", () => $d1036e2f13271908$export$58da9968c3170cb1);
let $d1036e2f13271908$var$debugEnabled = false;
let $d1036e2f13271908$var$stacktracesEnabled = false;
const $d1036e2f13271908$var$LOG_PREFIX = '[Frontend PubSub] ';
function $d1036e2f13271908$export$748ada60eaf985cc(enable) {
    $d1036e2f13271908$var$debugEnabled = enable;
}
function $d1036e2f13271908$export$4f7017086af31c25(enable) {
    $d1036e2f13271908$var$stacktracesEnabled = enable;
}
function $d1036e2f13271908$export$2a858f450a2f66d() {
    if ($d1036e2f13271908$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $d1036e2f13271908$export$4cdc8edb1e3c510c(msg, ...args) {
    if ($d1036e2f13271908$var$debugEnabled) // eslint-disable-next-line no-console
    console.log($d1036e2f13271908$var$LOG_PREFIX + msg, ...args);
}
function $d1036e2f13271908$export$89c0607256d35f0a(msg, ...args) {
    // eslint-disable-next-line no-console
    console.info($d1036e2f13271908$var$LOG_PREFIX + msg, ...args);
}
function $d1036e2f13271908$export$58da9968c3170cb1(msg, ...args) {
    // eslint-disable-next-line no-console
    console.error($d1036e2f13271908$var$LOG_PREFIX + msg, ...args);
}

});

parcelRegister("8qNPu", function(module, exports) {

$parcel$export(module.exports, "default", () => $114396df5e777e12$export$2e2bcd8739ae039);

var $fMN5M = parcelRequire("fMN5M");

var $96TaD = parcelRequire("96TaD");

var $ltVbq = parcelRequire("ltVbq");

var $5DEsG = parcelRequire("5DEsG");

var $jBddV = parcelRequire("jBddV");
class $114396df5e777e12$export$2e2bcd8739ae039 extends (0, $jBddV.default) {
    static{
        this.MSG_BOUNDARY = '\n';
    }
    static{
        this.PARAM_SUBSCRIBE_TO_CHANNELS = 'subscribeToChannels';
    }
    static{
        this.PARAM_REPLAY_FROM = 'replayFrom';
    }
    constructor(params){
        super(params), this.networkUp = false, this.abortController = null, this.isHidden = false, this.visibilityChangeListener = this.onVisibilityChange.bind(this);
    }
    transportType() {
        return (0, $ltVbq.APSTransportType).HTTP;
    }
    onVisibilityChange() {
        this.isHidden = document.visibilityState === 'hidden';
    }
    subscribe(channels) {
        if (channels == null || channels.size === 0) {
            (0, $96TaD.logDebug)('channel list is null or empty. HTTP request is not going to be sent.');
            return Promise.resolve();
        }
        const url = new URL(this.baseUrl);
        url.searchParams.set(// The list of channels to subscribe to is passed as a query parameter.
        $114396df5e777e12$export$2e2bcd8739ae039.PARAM_SUBSCRIBE_TO_CHANNELS, [
            ...channels
        ].join(','));
        if (this.abortController !== null) return this.connectWithBackoff(()=>this.reconnectWithNewSubscriptionSet(url));
        return this.connectWithBackoff(()=>this.makeHttpRequest(url));
    }
    close() {
        (0, $96TaD.logDebug)('Connection was closed by client');
        this.networkUp = false;
        // @ts-ignore: not sure why typecheck doesn't allow me to pass a parameter here. https://developer.mozilla.org/en-US/docs/Web/API/AbortController/abort#syntax
        this.abortController?.abort('CLOSED_BY_CLIENT');
    }
    reconnectWithNewSubscriptionSet(url) {
        // @ts-ignore: not sure why typecheck doesn't allow me to pass a parameter here. https://developer.mozilla.org/en-US/docs/Web/API/AbortController/abort#syntax
        this.abortController.abort('NEW_SUBSCRIPTION_SET');
        return new Promise((resolve)=>{
            // puts the call to makeHttpRequest at the back of the execution queue,
            // so the error handler code triggered by aborting the request can execute first.
            setTimeout(()=>{
                resolve(this.makeHttpRequest(url));
            }, 0);
        });
    }
    reconnect(url) {
        if (this.abortController?.signal?.aborted) // if the request was aborted, we don't reconnect.
        return Promise.resolve();
        if (this.lastSeenSequenceNumber) // Apply the "replay" mechanism to the request. This will ensure that, as soon as the connection is established,
        // APS will deliver all messages that were emitted in the time between when the previous request was closed (due
        // to time out) and the time the new request is successfully established.
        url.searchParams.set($114396df5e777e12$export$2e2bcd8739ae039.PARAM_REPLAY_FROM, this.lastSeenSequenceNumber.toString());
        return this.makeHttpRequest(url);
    }
    async makeHttpRequest(urlWithParams) {
        // AbortController allows us to abort the HTTP request - in case the "close" function is called, or the list of
        // subscribed channels change.
        document.addEventListener('visibilitychange', this.visibilityChangeListener);
        this.abortController = new AbortController();
        // @ts-ignore "fetch" should be able to take a URL as parameter. https://developer.mozilla.org/en-US/docs/Web/API/fetch#parameters
        const response = await fetch(urlWithParams, {
            signal: this.abortController?.signal
        });
        this.onFetchSuccessful(response);
        try {
            await this.processResponse(response);
        } catch (error) {
            if (!this.isAbortError(error)) {
                this.analyticsClient.sendEvent('aps-http', 'reconnecting');
                return this.reconnectWithBackoff(this.isHidden, ()=>this.reconnect(urlWithParams));
            }
        }
    }
    onFetchSuccessful(response) {
        if (!this.networkUp) {
            this.networkUp = true;
            // Emit the "NETWORK_UP" event only when the first request is completed. This ensures that the event
            // is not sent on reconnects that happen due to natural timeout.
            this.eventEmitter.emit((0, $fMN5M.EventType).NETWORK_UP, {});
        }
        this.lastSeenSequenceNumber = (0, $5DEsG.getTimestampBasedSequenceNumber)();
        return response;
    }
    isAbortError(error) {
        if (error.name === 'AbortError') {
            (0, $96TaD.logDebug)('Request was intentionally aborted. Reason: ' + // @ts-ignore AbortSignal does contain a property called "reason". https://developer.mozilla.org/en-US/docs/Web/API/AbortSignal/reason
            this.abortController?.signal?.reason);
            return true;
        }
        return false;
    }
    emitMessage(sanitizedChunk) {
        const messageData = JSON.parse(sanitizedChunk);
        this.lastSeenSequenceNumber = messageData.sequenceNumber || null;
        this.eventEmitter.emit((0, $fMN5M.EventType).MESSAGE, messageData.type, messageData.payload);
    }
    async processResponse(response) {
        // Read the contents of the response using a "reader", so the chunks can be consumed as soon as they're received,
        // in other words, we don't need to wait for the request to be completed (which can take a long time) to process
        // response contents.
        const reader = response?.body?.getReader();
        if (reader === null || reader === undefined) {
            this.analyticsClient.sendEvent('aps-http', 'null response');
            (0, $96TaD.logDebug)('Response body from APS request was null');
            return;
        }
        const decoder = new TextDecoder();
        const consumeChunk = (result)=>{
            const chunk = decoder.decode(result.value || new Uint8Array(), {
                stream: !result.done
            });
            chunk// Multiple messages can be delivered in the same chunk, so we split the chunk using the boundary character(s)
            .split($114396df5e777e12$export$2e2bcd8739ae039.MSG_BOUNDARY).filter((chunkPart)=>chunkPart.trim() !== '').forEach((sanitizedChunk)=>this.emitMessage(sanitizedChunk));
            if (result.done) return;
            else return readChunk();
        };
        const readChunk = async ()=>{
            const chunk = await reader.read();
            return consumeChunk(chunk);
        };
        return readChunk();
    }
}

});
parcelRegister("5DEsG", function(module, exports) {

$parcel$export(module.exports, "APS_STARGATE_PATH", () => $751811e6676ac2d4$export$8affde3f03b7d8fb);
$parcel$export(module.exports, "reconnectBackoffOptions", () => $751811e6676ac2d4$export$bda402bf18c1d4b0);
$parcel$export(module.exports, "firstConnectBackoffOptions", () => $751811e6676ac2d4$export$92d03939bb475e59);
$parcel$export(module.exports, "getTimestampBasedSequenceNumber", () => $751811e6676ac2d4$export$ed5ea3826f96c187);

var $VSDnB = parcelRequire("VSDnB");
const $751811e6676ac2d4$export$8affde3f03b7d8fb = '/gateway/wss/fps';
const $751811e6676ac2d4$export$bda402bf18c1d4b0 = (isHidden)=>{
    return {
        delayFirstAttempt: true,
        startingDelay: $751811e6676ac2d4$export$32bac9bcf9e91395(isHidden) ? 5000 + Math.random() * 300000 : 500 + Math.random() * 180000,
        timeMultiple: 2,
        numOfAttempts: 5,
        maxDelay: 300000
    };
};
const $751811e6676ac2d4$export$92d03939bb475e59 = (isFallback)=>{
    return {
        delayFirstAttempt: (0, $VSDnB.fg)('platform-delay-retries-on-first-connect-fps'),
        startingDelay: (0, $VSDnB.fg)('platform-delay-retries-on-first-connect-fps') ? 500 + Math.random() * 180000 : 200,
        timeMultiple: 2,
        numOfAttempts: isFallback ? 5 : 3,
        maxDelay: 600000
    };
};
const $751811e6676ac2d4$export$ed5ea3826f96c187 = ()=>{
    return Math.floor(new Date().getTime() / 1000); // timestamp in seconds
};
const $751811e6676ac2d4$export$32bac9bcf9e91395 = (isHidden)=>{
    return isHidden && (0, $VSDnB.fg)('platform-delay-retries-for-clients-on-fps');
};

});

parcelRegister("jBddV", function(module, exports) {

$parcel$export(module.exports, "default", () => $b618ccb6d8381013$export$2e2bcd8739ae039);

var $5DEsG = parcelRequire("5DEsG");

var $bsyZ4 = parcelRequire("bsyZ4");
class $b618ccb6d8381013$export$2e2bcd8739ae039 {
    constructor(params){
        this.lastSeenSequenceNumber = null;
        this.baseUrl = params.url;
        this.eventEmitter = params.eventEmitter;
        this.analyticsClient = params.analyticsClient;
        this.isFallback = params.isFallback;
    }
    async connectWithBackoff(connectFn) {
        return (0, $bsyZ4.backOff)(connectFn, {
            ...(0, $5DEsG.firstConnectBackoffOptions)(this.isFallback),
            retry: (e, count)=>{
                this.analyticsClient.sendEvent(this.analyticsSubject(), 'retrying connect', {
                    errorMessage: e?.message || 'unknown',
                    count: count
                });
                return true;
            }
        });
    }
    async reconnectWithBackoff(isHidden, reconnectFn) {
        if (!this.lastSeenSequenceNumber) // will replay messages that were supposed to be received while we were retrying
        this.lastSeenSequenceNumber = (0, $5DEsG.getTimestampBasedSequenceNumber)();
        return (0, $bsyZ4.backOff)(reconnectFn, {
            ...(0, $5DEsG.reconnectBackoffOptions)(isHidden),
            retry: (e, count)=>{
                this.analyticsClient.sendEvent(this.analyticsSubject(), 'retrying reconnect', {
                    errorMessage: e?.message || 'unknown',
                    count: count
                });
                return true;
            }
        });
    }
    analyticsSubject() {
        return `aps-${this.transportType()}`.toLowerCase();
    }
}

});
parcelRegister("bsyZ4", function(module, exports) {
"use strict";
var $857d72506b725747$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $857d72506b725747$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4ZQen = parcelRequire("4ZQen");

var $8MvwP = parcelRequire("8MvwP");
function $857d72506b725747$var$backOff(request, options) {
    if (options === void 0) options = {};
    return $857d72506b725747$var$__awaiter(this, void 0, void 0, function() {
        var sanitizedOptions, backOff;
        return $857d72506b725747$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    sanitizedOptions = $4ZQen.getSanitizedOptions(options);
                    backOff = new $857d72506b725747$var$BackOff(request, sanitizedOptions);
                    return [
                        4 /*yield*/ ,
                        backOff.execute()
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
            }
        });
    });
}
module.exports.backOff = $857d72506b725747$var$backOff;
var $857d72506b725747$var$BackOff = /** @class */ function() {
    function BackOff(request, options) {
        this.request = request;
        this.options = options;
        this.attemptNumber = 0;
    }
    BackOff.prototype.execute = function() {
        return $857d72506b725747$var$__awaiter(this, void 0, void 0, function() {
            var e_1, shouldRetry;
            return $857d72506b725747$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.attemptLimitReached) return [
                            3 /*break*/ ,
                            7
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            4,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.applyDelay()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.request()
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 4:
                        e_1 = _a.sent();
                        this.attemptNumber++;
                        return [
                            4 /*yield*/ ,
                            this.options.retry(e_1, this.attemptNumber)
                        ];
                    case 5:
                        shouldRetry = _a.sent();
                        if (!shouldRetry || this.attemptLimitReached) throw e_1;
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 6:
                        return [
                            3 /*break*/ ,
                            0
                        ];
                    case 7:
                        throw new Error("Something went wrong.");
                }
            });
        });
    };
    Object.defineProperty(BackOff.prototype, "attemptLimitReached", {
        get: function() {
            return this.attemptNumber >= this.options.numOfAttempts;
        },
        enumerable: true,
        configurable: true
    });
    BackOff.prototype.applyDelay = function() {
        return $857d72506b725747$var$__awaiter(this, void 0, void 0, function() {
            var delay;
            return $857d72506b725747$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        delay = $8MvwP.DelayFactory(this.options, this.attemptNumber);
                        return [
                            4 /*yield*/ ,
                            delay.apply()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return BackOff;
}();

});
parcelRegister("4ZQen", function(module, exports) {
"use strict";
var $3a355fe7b971a54e$var$__assign = module.exports && module.exports.__assign || function() {
    $3a355fe7b971a54e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3a355fe7b971a54e$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $3a355fe7b971a54e$var$defaultOptions = {
    delayFirstAttempt: false,
    jitter: "none",
    maxDelay: Infinity,
    numOfAttempts: 10,
    retry: function() {
        return true;
    },
    startingDelay: 100,
    timeMultiple: 2
};
function $3a355fe7b971a54e$var$getSanitizedOptions(options) {
    var sanitized = $3a355fe7b971a54e$var$__assign($3a355fe7b971a54e$var$__assign({}, $3a355fe7b971a54e$var$defaultOptions), options);
    if (sanitized.numOfAttempts < 1) sanitized.numOfAttempts = 1;
    return sanitized;
}
module.exports.getSanitizedOptions = $3a355fe7b971a54e$var$getSanitizedOptions;

});

parcelRegister("8MvwP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6KTRA = parcelRequire("6KTRA");

var $iGgXu = parcelRequire("iGgXu");
function $664b435844906bbd$var$DelayFactory(options, attempt) {
    var delay = $664b435844906bbd$var$initDelayClass(options);
    delay.setAttemptNumber(attempt);
    return delay;
}
module.exports.DelayFactory = $664b435844906bbd$var$DelayFactory;
function $664b435844906bbd$var$initDelayClass(options) {
    if (!options.delayFirstAttempt) return new $6KTRA.SkipFirstDelay(options);
    return new $iGgXu.AlwaysDelay(options);
}

});
parcelRegister("6KTRA", function(module, exports) {
"use strict";
var $4eb25f42819b59e4$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $4eb25f42819b59e4$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4eb25f42819b59e4$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6mSOH = parcelRequire("6mSOH");
var $4eb25f42819b59e4$var$SkipFirstDelay = /** @class */ function(_super) {
    $4eb25f42819b59e4$var$__extends(SkipFirstDelay, _super);
    function SkipFirstDelay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SkipFirstDelay.prototype.apply = function() {
        return $4eb25f42819b59e4$var$__awaiter(this, void 0, void 0, function() {
            return $4eb25f42819b59e4$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.isFirstAttempt ? true : _super.prototype.apply.call(this)
                ];
            });
        });
    };
    Object.defineProperty(SkipFirstDelay.prototype, "isFirstAttempt", {
        get: function() {
            return this.attempt === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SkipFirstDelay.prototype, "numOfDelayedAttempts", {
        get: function() {
            return this.attempt - 1;
        },
        enumerable: true,
        configurable: true
    });
    return SkipFirstDelay;
}($6mSOH.Delay);
module.exports.SkipFirstDelay = $4eb25f42819b59e4$var$SkipFirstDelay;

});
parcelRegister("6mSOH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9vakh = parcelRequire("9vakh");
var $4a2f519b227db519$var$Delay = /** @class */ function() {
    function Delay(options) {
        this.options = options;
        this.attempt = 0;
    }
    Delay.prototype.apply = function() {
        var _this = this;
        return new Promise(function(resolve) {
            return setTimeout(resolve, _this.jitteredDelay);
        });
    };
    Delay.prototype.setAttemptNumber = function(attempt) {
        this.attempt = attempt;
    };
    Object.defineProperty(Delay.prototype, "jitteredDelay", {
        get: function() {
            var jitter = $9vakh.JitterFactory(this.options);
            return jitter(this.delay);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Delay.prototype, "delay", {
        get: function() {
            var constant = this.options.startingDelay;
            var base = this.options.timeMultiple;
            var power = this.numOfDelayedAttempts;
            var delay = constant * Math.pow(base, power);
            return Math.min(delay, this.options.maxDelay);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Delay.prototype, "numOfDelayedAttempts", {
        get: function() {
            return this.attempt;
        },
        enumerable: true,
        configurable: true
    });
    return Delay;
}();
module.exports.Delay = $4a2f519b227db519$var$Delay;

});
parcelRegister("9vakh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9wEeE = parcelRequire("9wEeE");

var $8O9KL = parcelRequire("8O9KL");
function $6eaf04d4b12660e6$var$JitterFactory(options) {
    switch(options.jitter){
        case "full":
            return $9wEeE.fullJitter;
        case "none":
        default:
            return $8O9KL.noJitter;
    }
}
module.exports.JitterFactory = $6eaf04d4b12660e6$var$JitterFactory;

});
parcelRegister("9wEeE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $6ef6501e3e7d7ad2$var$fullJitter(delay) {
    var jitteredDelay = Math.random() * delay;
    return Math.round(jitteredDelay);
}
module.exports.fullJitter = $6ef6501e3e7d7ad2$var$fullJitter;

});

parcelRegister("8O9KL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $669a8f034fa1d62b$var$noJitter(delay) {
    return delay;
}
module.exports.noJitter = $669a8f034fa1d62b$var$noJitter;

});




parcelRegister("iGgXu", function(module, exports) {
"use strict";
var $d9994ddab40dbabb$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6mSOH = parcelRequire("6mSOH");
var $d9994ddab40dbabb$var$AlwaysDelay = /** @class */ function(_super) {
    $d9994ddab40dbabb$var$__extends(AlwaysDelay, _super);
    function AlwaysDelay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AlwaysDelay;
}($6mSOH.Delay);
module.exports.AlwaysDelay = $d9994ddab40dbabb$var$AlwaysDelay;

});





parcelRegister("alHzf", function(module, exports) {

$parcel$export(module.exports, "default", () => $b282b733a47a8372$export$2e2bcd8739ae039);

var $96TaD = parcelRequire("96TaD");

var $fMN5M = parcelRequire("fMN5M");

var $41cu3 = parcelRequire("41cu3");

var $ltVbq = parcelRequire("ltVbq");

var $5DEsG = parcelRequire("5DEsG");

var $jBddV = parcelRequire("jBddV");
var $b282b733a47a8372$var$State = /*#__PURE__*/ function(State) {
    State[State["CLOSED"] = 0] = "CLOSED";
    State[State["CONNECTING"] = 1] = "CONNECTING";
    State[State["OPEN"] = 2] = "OPEN";
    State[State["RECONNECTING"] = 3] = "RECONNECTING";
    return State;
}($b282b733a47a8372$var$State || {});
class $b282b733a47a8372$export$2e2bcd8739ae039 extends (0, $jBddV.default) {
    constructor(params){
        super(params), this.activeChannels = new Set(), this.closedByClient = false, this.state = 0, this.isHidden = false, this.visibilityChangeListener = this.onVisibilityChange.bind(this);
        this.url = $b282b733a47a8372$export$2e2bcd8739ae039.toWssUrl(params.url);
    }
    transportType() {
        return (0, $ltVbq.APSTransportType).WEBSOCKET;
    }
    onVisibilityChange() {
        this.isHidden = document.visibilityState === 'hidden';
    }
    async initClient(channels) {
        document.addEventListener('visibilitychange', this.visibilityChangeListener);
        return new Promise((resolve, reject)=>{
            const ws = new (0, $41cu3.default)({
                url: this.url,
                onOpen: ()=>{
                    this.eventEmitter.emit((0, $fMN5M.EventType).NETWORK_UP, {});
                    this.closedByClient = false;
                    ws.send({
                        type: 'subscribe',
                        channels: channels,
                        replayFrom: this.lastSeenSequenceNumber || undefined
                    });
                    this.lastSeenSequenceNumber = (0, $5DEsG.getTimestampBasedSequenceNumber)();
                    resolve(ws);
                },
                onMessage: (event)=>{
                    const data = JSON.parse(event.data);
                    if (data.type === 'CHANNEL_ACCESS_DENIED') {
                        this.eventEmitter.emit((0, $fMN5M.EventType).ACCESS_DENIED, data.payload);
                        return;
                    }
                    this.lastSeenSequenceNumber = data.sequenceNumber;
                    this.eventEmitter.emit((0, $fMN5M.EventType).MESSAGE, data.type, data.payload);
                },
                onClose: (event)=>{
                    if (this.closedByClient) return;
                    this.eventEmitter.emit((0, $fMN5M.EventType).NETWORK_DOWN, {});
                    if (this.state === 1 || this.state === 3) {
                        reject('connection closed');
                        return;
                    }
                    if (this.state === 2) this.reconnect([
                        ...this.activeChannels
                    ]).then((websocketClient)=>{
                        this.websocketClient = websocketClient;
                    }).catch(reject);
                },
                onMessageSendError: (readyState)=>{},
                onError: (event)=>{
                    (0, $96TaD.logDebug)('Websocket onError', event);
                }
            });
        });
    }
    async connect(channels) {
        this.state = 1;
        return this.connectWithBackoff(async ()=>this.initClient(channels)).then((ws)=>{
            this.state = 2;
            return ws;
        });
    }
    async reconnect(channels) {
        this.state = 3;
        return this.reconnectWithBackoff(this.isHidden, async ()=>this.initClient(channels)).then((ws)=>{
            this.state = 2;
            return ws;
        });
    }
    async subscribe(channels) {
        const newChannels = [
            ...channels
        ].filter((channelName)=>!this.activeChannels.has(channelName));
        const removedChannels = [
            ...this.activeChannels
        ].filter((channelName)=>!channels.has(channelName));
        if (removedChannels.length === 0 && newChannels.length === 0) return Promise.resolve();
        newChannels.forEach((channel)=>this.activeChannels.add(channel));
        removedChannels.forEach((channel)=>this.activeChannels.delete(channel));
        if (!this.websocketClient) this.websocketClient = await this.connect(newChannels);
        else {
            if (newChannels.length > 0) await this.websocketClient?.send({
                type: 'subscribe',
                channels: Array.from(newChannels)
            });
            if (removedChannels.length > 0) await this.websocketClient?.send({
                type: 'unsubscribe',
                channels: Array.from(removedChannels)
            });
        }
    }
    close() {
        if (this.activeChannels.size > 0) {
            this.websocketClient?.send({
                type: 'unsubscribe',
                channels: Array.from(this.activeChannels)
            });
            this.activeChannels.clear();
        }
        this.closedByClient = true;
        this.lastSeenSequenceNumber = null;
        this.websocketClient?.close();
        this.websocketClient = undefined;
        this.state = 0;
    }
    static{
        this.toWssUrl = (apsUrl)=>{
            const wssUrl = new URL(apsUrl);
            wssUrl.protocol = 'wss';
            return wssUrl;
        };
    }
}

});
parcelRegister("41cu3", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d539aa3c41d29ed$export$2e2bcd8739ae039);
const $3d539aa3c41d29ed$var$noop = ()=>{};
class $3d539aa3c41d29ed$export$2e2bcd8739ae039 {
    constructor(params){
        this.url = params.url;
        this.onMessageSendError = params.onMessageSendError || $3d539aa3c41d29ed$var$noop;
        this.promise = this.initializeClient(params);
    }
    async initializeClient({ url: url, onMessage: onMessage = $3d539aa3c41d29ed$var$noop, onClose: onClose = $3d539aa3c41d29ed$var$noop, onOpen: onOpen = $3d539aa3c41d29ed$var$noop, onError: onError = $3d539aa3c41d29ed$var$noop }) {
        return new Promise((resolve, reject)=>{
            const websocket = new WebSocket(url.toString());
            websocket.addEventListener('open', (event)=>{
                onOpen(event);
                resolve(websocket);
            });
            websocket.addEventListener('message', (event)=>onMessage(event));
            websocket.addEventListener('error', (event)=>{
                onError(event);
            });
            websocket.addEventListener('close', (event)=>{
                onClose(event);
            });
        });
    }
    async send(message) {
        const websocket = await this.promise;
        if (websocket.readyState === WebSocket.OPEN) websocket.send(JSON.stringify(message));
        else this.onMessageSendError(websocket.readyState);
    }
    async close() {
        const websocket = await this.promise;
        if (websocket.readyState === WebSocket.OPEN || websocket.readyState === WebSocket.CONNECTING) websocket.close();
    }
}

});


parcelRegister("asKgz", function(module, exports) {

$parcel$export(module.exports, "default", () => $487ff7d3b2fa78c3$export$2e2bcd8739ae039);

var $96TaD = parcelRequire("96TaD");
var $487ff7d3b2fa78c3$export$2e2bcd8739ae039 = (analyticsWebClient)=>{
    if (analyticsWebClient) return new $487ff7d3b2fa78c3$var$DefaultAnalyticsClient(analyticsWebClient);
    return new $487ff7d3b2fa78c3$var$MockAnalyticsClient();
};
class $487ff7d3b2fa78c3$var$DefaultAnalyticsClient {
    constructor(analyticsWebClient){
        this.analyticsWebClient = analyticsWebClient;
    }
    sendEvent(subject, action, attributes) {
        this.analyticsWebClient.sendOperationalEvent({
            source: 'atlaskit/pubsub',
            action: action,
            actionSubject: subject,
            attributes: attributes
        });
    }
}
class $487ff7d3b2fa78c3$var$MockAnalyticsClient {
    sendEvent(subject, action, attributes) {
        (0, $96TaD.logDebug)('[Mock analytics client]', subject, action, attributes);
    }
}

});


parcelRegister("dS9cn", function(module, exports) {
$parcel$export(module.exports, "AbstractResource", () => (parcelRequire("99RON")).AbstractResource);

$parcel$export(module.exports, "utils", () => $6539d5230a113c0b$export$eab97d15b1788b8d);
parcelRequire("3bFmZ");
parcelRequire("99RON");

var $aF8YM = parcelRequire("aF8YM");

var $8Q0SU = parcelRequire("8Q0SU");
const $6539d5230a113c0b$export$eab97d15b1788b8d = $aF8YM;
const $6539d5230a113c0b$export$3b4c04cf7dad0e50 = $8Q0SU;

});
parcelRegister("3bFmZ", function(module, exports) {

$parcel$export(module.exports, "buildCredentials", () => $1dde2ae50887ec17$export$2ac26f1ab7eda637);
const $1dde2ae50887ec17$export$2ac26f1ab7eda637 = (secOptions)=>{
    return secOptions && secOptions.omitCredentials ? 'omit' : 'include';
};

});

parcelRegister("99RON", function(module, exports) {

$parcel$export(module.exports, "AbstractResource", () => $e1e58db2ea52ba80$export$4529f10aed0950d4);
class $e1e58db2ea52ba80$export$4529f10aed0950d4 {
    subscribe(onChange) {
        this.listeners.add(onChange);
        if (this.lastResult) // Notify subscribe of last result (i.e. initial state)
        onChange.result(this.lastResult);
    }
    unsubscribe(onChange) {
        this.listeners.delete(onChange);
    }
    notifyResult(result) {
        this.listeners.forEach((onChange)=>{
            onChange.result(result);
        });
    }
    notifyError(error) {
        this.listeners.forEach((onChange)=>{
            if (onChange.error) onChange.error(error);
        });
    }
    notifyInfo(info) {
        this.listeners.forEach((onChange)=>{
            if (onChange.info) onChange.info(info);
        });
    }
    notifyNotReady() {
        this.listeners.forEach((onChange)=>{
            if (onChange.notReady) onChange.notReady();
        });
    }
    constructor(){
        this.listeners = new Set();
    }
}

});

parcelRegister("aF8YM", function(module, exports) {

$parcel$export(module.exports, "requestService", () => $4cb3782fbf0bac5b$export$97bfde5a702aaeca);

var $tcn7E = parcelRequire("tcn7E");

var $VSDnB = parcelRequire("VSDnB");

var $gSA3s = parcelRequire("gSA3s");

var $3bFmZ = parcelRequire("3bFmZ");

var $2HFDN = parcelRequire("2HFDN");
const $4cb3782fbf0bac5b$export$97bfde5a702aaeca = (serviceConfig, options)=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options || (0, $2HFDN.defaultRequestServiceOptions);
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $2HFDN.buildUrl)(url, path, queryParams, secOptions);
    const headers = (0, $2HFDN.buildHeaders)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $3bFmZ.buildCredentials)(secOptions);
    const ignoreResponsePayload = options?.ignoreResponsePayload || false;
    // Get tracing headers from UFO
    const TRACING_HEADER_FOR_SERVICE_UTIL = 'platform_collab_provider_tracingheaders';
    const tracingHeaderEnabled = (0, $VSDnB.fg)('platform_collab_provider_tracingheaders');
    (0, $gSA3s.addFeatureFlagAccessed)(TRACING_HEADER_FOR_SERVICE_UTIL, tracingHeaderEnabled);
    let tracingHeaders = {};
    if (tracingHeaderEnabled) tracingHeaders = (0, $tcn7E.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    return fetch(requestUrl, requestOptions).then((response)=>{
        if (response.status === 204) return Promise.resolve();
        else if (response.ok) return ignoreResponsePayload ? Promise.resolve() : response.json();
        else if (response.status === 401 && refreshedSecurityProvider) // auth issue - try once
        return refreshedSecurityProvider().then((newSecOptions)=>{
            const retryServiceConfig = {
                url: url,
                securityProvider: ()=>newSecOptions
            };
            return $4cb3782fbf0bac5b$export$97bfde5a702aaeca(retryServiceConfig, options);
        });
        return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
    });
};

});
parcelRegister("2HFDN", function(module, exports) {

$parcel$export(module.exports, "defaultRequestServiceOptions", () => $d06f18f7b97ba436$export$160dbda113bfad3b);
$parcel$export(module.exports, "buildUrl", () => $d06f18f7b97ba436$export$b5cd97dee32de81d);
$parcel$export(module.exports, "buildHeaders", () => $d06f18f7b97ba436$export$7d6ed858a91629c3);
const $d06f18f7b97ba436$export$160dbda113bfad3b = {};
const $d06f18f7b97ba436$export$b5cd97dee32de81d = (baseUrl, path = '', queryParams, secOptions)=>{
    const searchParam = new URLSearchParams(// For relative urls, the URL class requires base to be set. It's ignored if a url is not relative.
    // Since we only care about search params it is fine to have any base url here.
    new URL(baseUrl, 'https://BASE_FALLBACK').search || undefined);
    baseUrl = baseUrl.split('?')[0];
    if (queryParams) {
        for(const key in queryParams)if (({}).hasOwnProperty.call(queryParams, key)) searchParam.append(key, queryParams[key]);
    }
    if (secOptions && secOptions.params) {
        for(const key in secOptions.params)if (({}).hasOwnProperty.call(secOptions.params, key)) {
            const values = secOptions.params[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)searchParam.append(key, values[i]);
            else searchParam.append(key, values);
        }
    }
    let separator = '';
    if (path && baseUrl.substr(-1) !== '/' && !path.startsWith('/')) separator = '/';
    let params = searchParam.toString();
    if (params) params = '?' + params;
    return `${baseUrl}${separator}${path}${params}`;
};
const $d06f18f7b97ba436$var$addToHeaders = (headers, keyValues)=>{
    if (keyValues) {
        for(const key in keyValues)if (({}).hasOwnProperty.call(keyValues, key)) {
            const values = keyValues[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)headers[key] = values[i];
            else headers[key] = values;
        }
    }
};
const $d06f18f7b97ba436$export$7d6ed858a91629c3 = (secOptions, extraHeaders)=>{
    const headers = {};
    $d06f18f7b97ba436$var$addToHeaders(headers, extraHeaders);
    if (secOptions) $d06f18f7b97ba436$var$addToHeaders(headers, secOptions.headers);
    return headers;
};

});


parcelRegister("8Q0SU", function(module, exports) {

$parcel$export(module.exports, "requestServiceMultipart", () => $6251c78b414c941c$export$8b13532c81e8ac89);

var $lGkPt = parcelRequire("lGkPt");

var $3bFmZ = parcelRequire("3bFmZ");

var $2HFDN = parcelRequire("2HFDN");

var $VSDnB = parcelRequire("VSDnB");

var $gSA3s = parcelRequire("gSA3s");

var $tcn7E = parcelRequire("tcn7E");
const $6251c78b414c941c$export$8b13532c81e8ac89 = async (serviceConfig, options = (0, $2HFDN.defaultRequestServiceOptions))=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options;
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $2HFDN.buildUrl)(url, path, queryParams, secOptions);
    const headers = (0, $2HFDN.buildHeaders)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $3bFmZ.buildCredentials)(secOptions);
    // Get tracing headers from UFO
    const TRACING_HEADER_FOR_SERVICE_UTIL = 'platform_collab_provider_tracingheaders';
    const tracingHeaderEnabled = (0, $VSDnB.fg)('platform_collab_provider_tracingheaders');
    (0, $gSA3s.addFeatureFlagAccessed)(TRACING_HEADER_FOR_SERVICE_UTIL, tracingHeaderEnabled);
    let tracingHeaders = {};
    if (tracingHeaderEnabled) tracingHeaders = (0, $tcn7E.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    const fetchResponse = await fetch(requestUrl, requestOptions);
    const parts = await (0, $lGkPt.meros)(fetchResponse);
    if (fetchResponse.ok && fetchResponse.status !== 204) {
        if (parts[Symbol.asyncIterator] < 'u') // this lets us know that the response is multipart
        //
        // 	((parts as PartsGenerator)[Symbol.asyncIterator] as any) < 'u' came from the `meros` docs:
        //	https://github.com/maraisr/meros/blob/dec4feaa24090b94e8ac42fab1aff38a1e521680/readme.md
        // 	Look for expand section `If the content-type is NOT a multipart, then meros will resolve with the response argument.`
        return {
            isMultipart: true,
            parts: parts
        };
        return {
            isMultipart: false,
            body: await parts.json()
        };
    } else if (fetchResponse.status === 401 && refreshedSecurityProvider) // auth issue - try once
    return refreshedSecurityProvider().then((newSecOptions)=>{
        const retryServiceConfig = {
            url: url,
            securityProvider: ()=>newSecOptions
        };
        return $6251c78b414c941c$export$8b13532c81e8ac89(retryServiceConfig, options);
    });
    return Promise.reject({
        code: fetchResponse.status,
        reason: fetchResponse.statusText
    });
};

});
parcelRegister("lGkPt", function(module, exports) {

$parcel$export(module.exports, "meros", () => $fc8dad7b24d7fa67$export$74e0a034be2368c7);
var $fc8dad7b24d7fa67$var$e = new TextDecoder;
async function $fc8dad7b24d7fa67$export$74e0a034be2368c7(t, n) {
    if (!t.ok || !t.body || t.bodyUsed) return t;
    let i = t.headers.get("content-type");
    if (!i || !~i.indexOf("multipart/")) return t;
    let l = i.indexOf("boundary="), r = "-";
    if (~l) {
        let e = l + 9, t = i.indexOf(";", e);
        r = i.slice(e, t > -1 ? t : void 0).trim().replace(/"/g, "");
    }
    return async function*(t, n, i) {
        let l, r, d, o = t.getReader(), a = !i || !i.multiple, f = n.length, s = "", c = [];
        try {
            let t;
            e: for(; !(t = await o.read()).done;){
                let i = $fc8dad7b24d7fa67$var$e.decode(t.value);
                l = s.length, s += i;
                let o = i.indexOf(n);
                for(~o ? l += o : l = s.indexOf(n), c = []; ~l;){
                    let e = s.slice(0, l), t = s.slice(l + f);
                    if (r) {
                        let n = e.indexOf("\r\n\r\n") + 4, i = e.lastIndexOf("\r\n", n), l = !1, r = e.slice(n, i > -1 ? void 0 : i), o = String(e.slice(0, n)).trim().split("\r\n"), f = {}, s = o.length;
                        for(; d = o[--s]; d = d.split(": "), f[d.shift().toLowerCase()] = d.join(": "));
                        if (d = f["content-type"], d && ~d.indexOf("application/json")) try {
                            r = JSON.parse(r), l = !0;
                        } catch (e) {}
                        if (d = {
                            headers: f,
                            body: r,
                            json: l
                        }, a ? yield d : c.push(d), "--" === t.slice(0, 2)) break e;
                    } else n = "\r\n" + n, r = f += 2;
                    s = t, l = s.indexOf(n);
                }
                c.length && (yield c);
            }
        } finally{
            c.length && (yield c), await o.cancel();
        }
    }(t.body, `--${r}`, n);
}

});






//# sourceMappingURL=@atlaskit-jira_pubsub.83bb353b.js.map
